import { Box, Typography } from "@mui/material";
import { useChatPdVContext } from "../../../../contexts/atendimento/ChatPdVContext";
import { useMoeda } from "../../../../../core/hooks/useMoeda";
import { TipoPedido } from "../../../../enum/TipoPedido";
import { cores, superficie, texto } from "../../identidade";

export const ChatPdVValores = () => {
    const { valorTotalPedido, valorFrete, tipo, valorDescontoTotal, cupons } = useChatPdVContext();
    const { real } = useMoeda();

    const temDesconto = cupons.length > 0 && valorDescontoTotal > 0;

    return (
        <Box sx={{ py: 0.5 }}>
            {temDesconto && (
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', mb: 0.5 }}>
                    <Typography sx={{ ...texto.corpo, color: 'text.secondary' }}>Subtotal</Typography>
                    <Typography sx={{ ...texto.corpo, color: 'text.secondary' }}>
                        {real(valorTotalPedido + valorDescontoTotal)}
                    </Typography>
                </Box>
            )}
            {temDesconto && (
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', mb: 0.5 }}>
                    <Typography sx={{ ...texto.corpo, color: 'success.main' }}>Descontos</Typography>
                    <Typography sx={{ ...texto.corpo, color: 'success.main', fontWeight: 700 }}>
                        -{real(valorDescontoTotal)}
                    </Typography>
                </Box>
            )}

            {/* Divisória pontilhada: separa o total do resto, como no site. */}
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'baseline',
                    pt: 1.25,
                    borderTop: theme => `1px dashed ${superficie(theme, 0.14)}`,
                }}
            >
                <Typography sx={{ ...texto.secao, color: 'text.secondary' }}>Total</Typography>
                <Typography sx={{ fontSize: '22px', fontWeight: 800, letterSpacing: '-0.02em' }}>
                    {real(valorTotalPedido)}
                </Typography>
            </Box>

            {tipo === TipoPedido.delivery && valorFrete != undefined && (
                <Typography sx={{ ...texto.apoio, color: 'text.secondary', textAlign: 'right', mt: 0.5 }}>
                    Frete de <Box component="span" sx={{ fontWeight: 700, color: cores.marca[500] }}>{real(valorFrete)}</Box> incluso
                </Typography>
            )}
        </Box>
    );
};

